// extracted by mini-css-extract-plugin
export default {"collection__wrapper":"collections_collection__wrapper__n4587","heading":"collections_heading__Raw63","categories__grid":"collections_categories__grid__9Umi3"};